import {
  FusionAuthLoginButton,
  RequireAuth,
  Unauthenticated,
} from "@fusionauth/react-sdk";
import { Button } from "@sane-ts/shadcn-ui";
import type { ReactNode } from "react";

export function AutoLogIn({ children }: { children: ReactNode }) {
  return (
    <>
      <Unauthenticated>
        <div className="grid h-full w-full place-items-center">
          <Button size={"lg"} asChild>
            <FusionAuthLoginButton
              state={location.href.slice(location.origin.length)}
            />
          </Button>
        </div>
      </Unauthenticated>
      <RequireAuth>{children}</RequireAuth>
    </>
  );
}
